import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { RuntimeConfigService } from '@app/service/runtime-config.service';
import { defer, from, Observable, of, shareReplay, map, tap } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { setOptions, importLibrary } from '@googlemaps/js-api-loader';

@Injectable({ providedIn: 'root' })
export class GoogleMapsService {
  private get key(): string {
    return this.runtimeConfigService.getConfig?.googleMapKey;
  }
  private scriptAdded = false;
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  constructor(private readonly runtimeConfigService: RuntimeConfigService) {}
  private readonly googleMaps$ = defer(() => {
    // Return empty observable for SSR
    if (!this.isBrowser) {
      return new Observable<void>();
    }

    // If already loaded, return immediately
    if (this.scriptAdded && window.google?.maps) {
      return of(void 0);
    }

    // Configure the Google Maps API
    setOptions({
      key: this.key,
      v: 'weekly',
      libraries: ['places']
    });

    // Import the places library
    return from(importLibrary('places')).pipe(
      tap(() => {
        this.scriptAdded = true;
      }),
      map(() => void 0)
    );
  }).pipe(shareReplay({ bufferSize: 1, refCount: true }));

  getGoogleMaps() {
    return this.googleMaps$;
  }
}
